<template>
  <div class="goup">
    <div
      class="btn"
      :class="{ 'btn-disabled': activityInfo.activity_state == 3 }"
      >{{
        activityInfo.activity_state == 3
          ? '活动已结束'
          : '教练暂不支持赠送小红花哦～'
      }}</div
    >

    <PrizeList />
  </div>
</template>

<script>
import PrizeList from './prize-list.vue'
export default {
  components: { PrizeList },
  data() {
    return {}
  },
  computed: {
    activityInfo() {
      return this.$store.state.coachActivity2024.activityInfo
    }
  },
  created() {},
  methods: {
    bindSend() {
      this.$store.commit('coachActivity2024/setShowSendFlowerToast', true)
    },
    bindMyPrize() {
      this.$store.commit('coachActivity2024/setMyPrizeToast', true)
    },
    bindGetFlower() {
      this.$store.commit('coachActivity2024/setTaskToast', true)
    },
    bindGetRecord() {
      this.$store.commit('coachActivity2024/setRecordToast', true)
    }
  }
}
</script>
<style lang="scss" scoped>
.goup {
  padding: 496px 10px 10px;
  .btn {
    height: 53px;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 41px;
    font-weight: bold;
    font-size: 16px;
    color: rgba(5, 11, 39, 0.5);
    line-height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
  }
}
</style>
